interface RuntimeConfig {
  REACT_APP_ENV: string;
}

declare global {
  interface Window {
    runtimeConfig: RuntimeConfig;
  }
}

const config: RuntimeConfig = { ...window.runtimeConfig };

export default config;
